import CapVerification from "./cap/CapVerification";
import AltchaVerification from "./AltchaVerification";
import type { Challenge } from "./client";
export default function Verification(props: {
  challenge: Challenge;
  onSolved: (pass: string) => void;
}) {
  return props.challenge.provider === "cap" ? (
    <CapVerification {...props} />
  ) : (
    <AltchaVerification {...props} />
  );
}
